export default __webpack_public_path__ + "static/media/THOMAS.40e6ae4f.png";